export default {
  SET_USER(state, payload) {
    state.user = payload;
  },
  SET_USER_LICENSE(state, payload) {
    state.userLicense = payload;
  },
  SET_SELECTED_LICENSE_CATEGORY(state, payload) {
    state.selectedLicenseCategory = payload;
  },
  SET_INPUT_FORM(state, payload) {
    state.inputForm = payload;
  },
  CLEAR_INPUT_FORM(state) {
    state.inputForm = {};
  },
  SET_PICTURE_SRC(state, payload) {
    state.pictureSrc = payload.pictureSrc;
  },
  SET_REGISTERED_LICENSE(state, payload) {
    state.registeredLicense = payload;
  },
  CLEAR_PICTURE_SRC(state) {
    state.pictureSrc = null;
  },
  RESET_STATE (state, data) {
    Object.assign(state, data)
  },
}
